import { t } from "i18next";

import { LevelProps } from "@/interfaces/components";

import { LevelSuccess } from "./components/LevelSuccess";
import styles from "./styles";

export const Levels = ({ levels, hideAction = false }: { levels: Array<LevelProps>; hideAction?: boolean }) => {
  return (
    <styles.Levels>
      {levels.map((level) => (
        <styles.Level
          key={level.level}
          $soon={level.soon}
          onClick={() => level.handler && level.actions && level.handler()}
          $clickable={Boolean(level.handler && level.actions)}
        >
          <img src={level.img} />
          <styles.Text>
            <span>{t("Levels.Level", { level: level.level })}</span>
            <span>{level.title}</span>
            {level.completed ? <LevelSuccess /> : level.additionalCompleted || null}
          </styles.Text>
          {!level.completed && !hideAction && level.actions}
        </styles.Level>
      ))}
    </styles.Levels>
  );
};
